import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { descrizioneFrequenzaDigest } from './contattiNotificheUtils';

const useStyles = makeStyles((theme) => ({
  riquadro: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.action.hover,
    textAlign: 'left',
  },
  frequenza: {
    fontWeight: 600,
  },
  nota: {
    color: theme.palette.text.secondary,
  },
}));

/**
 * The daily digest of the last 24 hours goes to the contatti di struttura
 * (US 16). This card is read-only by design: the frequency lives in the single
 * configuration point of BSDEVPLAT-97 (`iot.digest.*`), and changing it is an
 * environment variable and a redeploy — deliberately staged on Q8 (PO validation
 * 2026-08-06). Rendering a control here would promise an edit that does not
 * exist.
 *
 * `abilitato` is a service kill switch, not a per-esercizio switch, so it is
 * worded as one: the sentence names every esercizio, never this one alone.
 */
const DigestNotificheCard = ({ digest, caricamento }) => {
  const classes = useStyles();
  const frequenza = descrizioneFrequenzaDigest(digest);
  const spento = digest?.abilitato === false;

  // Before the read settles there is no missing configuration, only a
  // configuration that has not arrived: «non è stato possibile caricare» would
  // be a failure reported before the attempt.
  const frequenzaSconosciuta = !frequenza && !caricamento;

  return (
    <div className={classes.riquadro} data-testid="digest-notifiche">
      <Typography variant="subtitle2" component="h4">
        Riepilogo via email
      </Typography>
      <Typography variant="body2" component="p">
        I contatti di struttura ricevono per email il riepilogo delle deviazioni
        del periodo coperto.
      </Typography>
      {frequenza && (
        <Typography variant="body2" component="p" className={classes.frequenza}>
          {frequenza}
        </Typography>
      )}
      {caricamento && (
        <Typography variant="body2" component="p" className={classes.nota}>
          Caricamento della frequenza…
        </Typography>
      )}
      {frequenzaSconosciuta && (
        <Typography variant="body2" component="p" className={classes.nota}>
          Non è stato possibile caricare la frequenza del riepilogo. Ricarica la
          pagina per riprovare.
        </Typography>
      )}
      {spento && (
        <Typography variant="body2" component="p" className={classes.nota}>
          Il riepilogo è disattivato per tutti gli esercizi: al momento nessun
          contatto lo riceve.
        </Typography>
      )}
      <Typography variant="caption" component="p" className={classes.nota}>
        La frequenza è la stessa per tutti gli esercizi.
      </Typography>
    </div>
  );
};

DigestNotificheCard.propTypes = {
  digest: PropTypes.shape({
    abilitato: PropTypes.bool,
    frequenza: PropTypes.string,
    finestraCoperta: PropTypes.string,
    oraDiInvio: PropTypes.string,
    fusoOrario: PropTypes.string,
  }),
  // The read of the configuration is still in flight: no sentence about the
  // frequency, and above all no failure sentence.
  caricamento: PropTypes.bool,
};

export default DigestNotificheCard;
